import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const listDepartmentsStart = createAction(
  'LIST_DEPARTMENTS::START',
  withPayloadType<{ organizationId: string }>(),
);
